<template>
  <div class="layout-product">
    <div class="layout-product-left" :class="{ unLogin: !isLogin }">
      <a class="clear-all-search" href="javascript:;" @click="clearAllSearch">
        {{ letter.v3Clear }}
      </a>
      <div class="left-wrap">
        <div class="search-input-wrap" v-if="showToolBar">
          <input
            :placeholder="searchPlaceholder[curSearchType]"
            class="search-input"
            v-model.trim="searchVal"
            ref="searchInput"
          />
          <Icon class="search-input-ico" name="search"></Icon>
        </div>
        <div class="classify">
          <div class="classify-title" v-if="productType.length > 0">
            {{ letter.v3Category }}
          </div>
          <ul class="classify-list">
            <li
              class="classify-list-item j-select-product-type"
              :key="item.value"
              v-for="item in productType"
              @click="updateProductType(item.value)"
            >
              <div class="classify-list-item-wrap">
                <div
                  class="classify-list-item-wrap-select"
                  :class="{ active: curProductType.includes(item.value) }"
                ></div>
                <div class="classify-list-item-content">
                  <span class="classify-list-item-content-icon">
                    <img
                      v-if="productTypeImg(item)"
                      :src="productTypeImg(item)"
                      alt=""
                    />
                  </span>
                  <span class="classify-list-item-content-name">{{
                    item.name
                  }}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="sort">
          <div class="sort-title">{{ letter.v3Sort }}</div>
          <ul class="sort-list">
            <li class="sort-list-item">
              <a
                href="javascript:;"
                class="sort-list-item-check"
                :class="{ active: curOrderType == PRODUCT_ORDER_BY_PRICE_DOWN }"
                @click="updateOrderType(PRODUCT_ORDER_BY_PRICE_DOWN)"
              >
                <span class="sort-list-item-check-icon"></span>
                {{ letter.storePriceDown }}
              </a>
            </li>
            <li class="sort-list-item">
              <a
                href="javascript:;"
                class="sort-list-item-check"
                :class="{ active: curOrderType == PRODUCT_ORDER_BY_PRICE_UP }"
                @click="updateOrderType(PRODUCT_ORDER_BY_PRICE_UP)"
              >
                <span class="sort-list-item-check-icon"></span>
                {{ letter.storePriceUp }}
              </a>
            </li>
          </ul>
        </div>
        <div class="filter">
          <div class="filter-title">{{ letter.v3PriceRange }}</div>
          <div class="filter-content">
            <div class="filter-content-input">
              <input
                type="text"
                :placeholder="letter.v3Min"
                v-model="minPrice"
              />
              <span class="filter-content-input-bg"></span>
            </div>
            -
            <div class="filter-content-input">
              <input
                type="text"
                :placeholder="letter.v3Max"
                v-model="maxPrice"
              />
              <span class="filter-content-input-bg"></span>
            </div>
          </div>
          <a href="javascript:;" class="filter-btn">{{ letter.v3Filter }}</a>
        </div>
      </div>
    </div>
    <div class="layout-product-right">
      <div
        class="select-product"
        :class="{
          'show-popup-status':
            visibleCurrenyGuidePopup ||
            productDetailPopupVisible ||
            showCartList
        }"
      >
        <div class="header-wrap-group">
          <!-- 移动端 -->
          <div class="header-wrap mobile" v-if="showToolBar">
            <div class="title">
              <span class="title-icon" :style="titleIconStyle"></span>
              <span class="title-text">{{ selectProductTitle }}</span>
            </div>
            <!-- 搜索 -->
            <div class="search-input-wrap" v-if="showToolBar">
              <input
                :placeholder="searchPlaceholder[curSearchType]"
                class="search-input"
                v-model.trim="searchVal"
                ref="searchInput"
              />
              <Icon class="search-input-ico" name="search"></Icon>
            </div>
            <!-- 分类、价格排序 -->
            <div class="filter-btn">
              <button
                v-show="showTypeBtn"
                class="order-btn flex-between j-select-order"
                :class="{ active: isShowTypeSelecter }"
                @click.stop="updateOrderType(PRODUCT_ORDER_BY_TYPE)"
              >
                <span>{{ currencyTypeName || selectProductTitle }}</span>
                <Icon class="order-btn-icon" name="down"></Icon>
              </button>
              <button
                class="order-btn flex-between j-select-order"
                :class="{ active: curOrderType !== PRODUCT_ORDER_BY_PRICE_UP }"
                @click.stop="showPriceSelecterHandle"
              >
                {{
                  curOrderType === PRODUCT_ORDER_BY_PRICE_DOWN
                    ? letter.storePriceDown
                    : letter.storePriceUp
                }}
                <Icon class="order-btn-icon" name="down"></Icon>
              </button>
            </div>
          </div>
          <!-- 分类选择弹窗 -->
          <div
            class="order-type-popup shadow"
            v-show="isShowTypeSelecter"
            v-clickoutside="hideTypeSelecterHandle"
          >
            <div
              class="order-type-popup-close"
              @click="hideTypeSelecterHandle"
            ></div>
            <div class="order-type-content">
              <div
                class="product-type-select-item j-select-product-type"
                :pointValue="item.value"
                pointClass="`j-select-product-type`"
                :key="item.value"
                v-for="item in productType"
                @click="updateProductType(item.value)"
                :id="`j-product-type-${item.value}`"
              >
                <div
                  class="product-type-select-item-bg"
                  :class="{ active: curProductType.includes(item.value) }"
                ></div>
                <img
                  v-if="productTypeImg(item)"
                  :src="productTypeImg(item)"
                  class="type-img"
                  alt=""
                />
                <p class="type-name">{{ item.name }}</p>
                <span
                  v-if="curProductType.includes(item.value)"
                  class="type-check"
                ></span>
              </div>
            </div>
          </div>
          <!-- 价格选择弹窗 -->
          <div
            class="price-type-popup shadow"
            :class="{ left: !showTypeBtn }"
            v-show="isShowPriceSelecter"
            v-clickoutside="hidePriceSelecterHandle"
          >
            <div
              class="price-item"
              :class="{ active: curOrderType == PRODUCT_ORDER_BY_PRICE_DOWN }"
              @click="updateOrderType(PRODUCT_ORDER_BY_PRICE_DOWN)"
            >
              {{ letter.storePriceDown }}
            </div>
            <div
              class="price-item"
              :class="{ active: curOrderType == PRODUCT_ORDER_BY_PRICE_UP }"
              @click="updateOrderType(PRODUCT_ORDER_BY_PRICE_UP)"
            >
              {{ letter.storePriceUp }}
            </div>
          </div>
        </div>
        <slot name="limitedTimeActivity"></slot>

        <div class="header-wrap pc">
          <div class="title">
            <span class="title-icon" :style="titleIconStyle"></span>
            <span class="title-text">{{ selectProductTitle }}</span>
          </div>
        </div>
        <div class="product-wrap" v-if="showRealProductList">
          <product-item
            v-for="(item, index) in filterProductList"
            :key="item.PRODUCT_ID + item.CP_PRODUCT_ID + index"
            :item="item"
            @selectProduct="selectProduct"
            @showDetailPopup="showProductDetailPopup"
            @clickAddToCart="beforeAddToCartCheck"
            :selectItem="selectItem"
            :isPreProduct="false"
          ></product-item>
        </div>
        <div class="product-wrap" v-else>
          <product-item
            v-for="(item, index) in filterPreProductList"
            :key="item.PRODUCT_ID + index"
            :item="item"
            selectItem=""
            :isPreProduct="true"
            @showLoginPopup="handlerPopup"
            @selectProduct="handlerPopup"
            @clickAddToCart="handlerPopup"
            @showDetailPopup="showProductDetailPopup"
          ></product-item>
        </div>
        <div class="product-more-wrap" v-if="showMoreBtn">
          <a
            class="product-more-btn"
            href="javascript:;"
            @click="showMoreProduct"
          >
            {{ letter.storeLookMore
            }}<Icon class="product-more-btn-icon" name="double-down"></Icon>
          </a>
        </div>
        <slot></slot>
        <transition name="fade">
          <cart-submit-footer
            v-if="openShoppingCart && isLogin"
            :boolShowMoreProduct="boolShowMoreProduct"
            @showLoginPopup="handlerPopup"
          ></cart-submit-footer>
        </transition>
        <transition name="fade">
          <AreaConfirmPopup
            v-if="showAreaConfirmPopup"
            :havePayWay="havePayWay"
            @hidePopup="handleAreaConfirmPopup(false)"
            @confirmSwitchArea="confirmSwitchArea"
            @handleZipCodeConfirmPopup="handleZipCodeConfirmPopup"
          ></AreaConfirmPopup>
        </transition>
        <transition name="fade">
          <ZipCodeConfirmPopup
            v-if="showZipCodeConfirmPopup"
            mode=""
            @handleZipCodeConfirmPopup="handleZipCodeConfirmPopup"
            @confirmSwitchArea="confirmSwitchArea"
          ></ZipCodeConfirmPopup>
        </transition>
        <CommonUidTokenLoginPopup
          v-bind:visible.sync="visibleAreaCommonTokenLoginPopup"
        ></CommonUidTokenLoginPopup>
        <PopupWindow
          @onCancel="areaErrorPopup = false"
          @onConfirm="areaErrorPopup = false"
          type="tips"
          v-if="areaErrorPopup"
          :languages="letter"
          :content="areaErrorTips"
        ></PopupWindow>
        <about-currency-popup
          v-bind:visible.sync="visibleCurrenyGuidePopup"
        ></about-currency-popup>
        <product-detail-popup
          style="z-index: 1001"
          v-if="productDetailPopupVisible"
          @selectProduct="selectProduct"
          @clickAddToCart="beforeAddToCartCheck"
          @closeSelecter="hideProductDetailPopup"
          :showBtn="showDeatilBtn"
          :showChildSelector="productDetailPopupVisible"
          :product="productDetailPopupProduct"
        ></product-detail-popup>
        <!-- 加入购物车商品限购弹窗 -->
        <PopupWindow
          v-if="showLifeLimitPopup"
          :languages="letter"
          :content="lifeLimitProductContent"
          :title="letter.v3Notice"
          :confirm="letter.v3LifeLimitConfirmAddToCart"
          :cancel="letter.v3LifeLimitCancelAddToCart"
          textAlign="center"
          @onConfirm="doAddToCart(lifeLimitProductItem)"
          @onCancel="showLifeLimitPopup = false"
        ></PopupWindow>
        <!-- RO无可购列表弹窗 -->
        <PopupWindow
          v-if="showNoAvailableProductsPopup"
          :languages="letter"
          type="tips"
          :content="letter.v3NoAvailableProducts"
          textAlign="center"
          @onConfirm="handlerPopup"
          @onCancel="hideNoAvailableProductsPopup"
        ></PopupWindow>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { getProductDefaultImg } from '@utiles/officialStore/productImg';
import globalConfig from '@utiles/officialStore/globalConfig';
import { errorReport, ERROR_TYPE } from '@utiles/errorReport';
import {
  SET_HAS_LOAD_PAYTYPE,
  UPDATE_LOADING,
  LOAD_PAYTYPE_LIST_DATA,
  UPDATE_HAS_SELECT_PRODUCT,
  GET_PRE_PRODUCT_LIST,
  SHOW_PRODUCT_DETAIL_POPUP,
  CLOSE_PRODUCT_DETAIL_POPUP,
  UPDATE_IS_AUTO_MATCH_PRODUCT,
  RESOLVE_PRODUCT_ID_FOR_COIN
} from '@store/officialTopupNew';
import {
  storeProductParam,
  storeCpProductId,
  getCurLocation,
  setDefaultPrice
} from '@store/officialTopupNew/storager';
import {
  LOAD_CART_PAYTYPE_LIST_DATA,
  UPDATE_SHOW_CARTLIST_STATUS
} from '@store/officialTopupNew/cart';
import {
  PRODUCT_TYPE_ALL,
  PRODUCT_TYPE_OTHER,
  PRODUCT_SEARCH_BY_NAME,
  PRODUCT_SEARCH_BY_PRICE,
  PRODUCT_ORDER_BY_NORMAL,
  PRODUCT_ORDER_BY_TYPE,
  PRODUCT_ORDER_BY_PRICE_UP,
  PRODUCT_ORDER_BY_PRICE_DOWN
} from '@store/officialTopupNew/const';
import ProductItem from '@components/officialTopupNew/product/ProductItem.vue';
import SearchTypeSelecter from '@components/officialTopupNew/product/SearchTypeSelecter';
import ProductDetailPopup from '@components/officialTopupNew/product/ProductDetailPopup.vue';
import AboutCurrencyPopup from '@components/officialTopupNew/AboutCurrencyPopup.vue';
import CartSubmitFooter from '@components/officialTopupNew/cart/CartSubmitFooter.vue';
import RecommendProduct from '@components/officialTopupNew/product/RecommendProduct.vue';
import AreaConfirmPopup from '@components/officialTopupNew/paytype/AreaConfirmPopup';
import ZipCodeConfirmPopup from '@components/officialTopupNew/paytype/ZipCodeConfirmPopup';
import CommonUidTokenLoginPopup from '@components/officialTopupNew/login/CommonUidTokenLoginPopup';

import coupon from '@mixins/officialTopupNew/coupon';
import login from '@mixins/officialTopupNew/login';
import pay from '@mixins/officialTopupNew/pay';
import style from '@mixins/officialTopupNew/style';
import cartAddAndDetail from '@mixins/officialTopupNew/cartAddAndDetail';
import product from '@mixins/officialTopupNew/product';
import switchArea from '@mixins/officialTopupNew/switchArea';

import clickOutside from '../../../diractives/officialStore/clickOutside';
import { mapState, mapGetters } from 'vuex';
import { commonEmitUpload } from '../../../plugins/AnalyzePoint/index';
import {
  popupType,
  showPopup,
  clickButton,
  locationType
} from '@plugins/biPoint/_configWebstoreV35';
import { trackStagePoint } from '@utiles/officialTopupNew/speedPoint';
const isFromIframe = globalConfig.getHrefParam('fromIframe') || '';
const PRODUCT_OFF_POPUP_HIDE = 'PRODUCT_OFF_POPUP_HIDE';
const PACKAGE_TAG_LIST = [
  'hot',
  'discount',
  'double',
  'treble',
  'sale',
  'top_seller',
  'off_10',
  'off_20',
  'off_30',
  'off_40',
  'off_50',
  'off_60',
  'off_70',
  'off_80',
  'off_90',
  'event',
  'daily',
  'weekly',
  'monthly'
];
export default {
  name: 'webSelectProduct',
  mixins: [coupon, login, pay, style, cartAddAndDetail, product, switchArea],
  data() {
    let productIdForCoinResolve = () => {};
    let productIdForCoinPromise = new Promise(resolve => {
      productIdForCoinResolve = resolve;
    });

    return {
      uidGame: globalConfig.isUidGame(),
      mainHost: globalConfig.getMainHost(),
      curOrderType: PRODUCT_ORDER_BY_NORMAL,
      curProductType: [],
      searchVal: '',
      scroll: null,
      isShowTypeSelecter: false,
      isShowPriceSelecter: false,
      currencyType: '',
      selectItem: {},
      hasAutoSelect: false,
      curSearchType: PRODUCT_SEARCH_BY_NAME,
      PRODUCT_OFF_POPUP_HIDE,
      preProductList: [],
      visibleCurrenyGuidePopup: false,
      isExpandAllType: false,
      showSearchTypeSelecter: false,
      isGoSearch: false,
      debounce: null,
      showDeatilBtn: true,
      boolShowMoreProduct: false,
      minPrice: undefined,
      maxPrice: undefined,
      productIdForCoin: '',
      productIdForCoinPromise,
      productIdForCoinResolve,
      PRODUCT_ORDER_BY_TYPE,
      PRODUCT_ORDER_BY_PRICE_UP,
      PRODUCT_ORDER_BY_PRICE_DOWN
    };
  },
  async created() {
    this.transformProductId();
    this.$store.dispatch(GET_PRE_PRODUCT_LIST).then(data => {
      if (+this.gameId === 386) {
        const roShowProductArr = [
          'com.gravitygamevision.roworld.aos.dm1',
          'com.gravitygamevision.roworld.aos.dm2',
          'com.gravitygamevision.roworld.aos.dm3',
          'com.gravitygamevision.roworld.aos.dm4',
          'com.gravitygamevision.roworld.aos.dm5',
          'com.gravitygamevision.roworld.aos.dm6'
        ];
        this.preProductList =
          data?.filter(item =>
            roShowProductArr.includes(String(item.PRODUCT_ID))
          ) || [];
        return;
      }
      this.preProductList = data;
    });
  },
  watch: {
    allProductList: {
      deep: true,
      immediate: true,
      async handler(newVal) {
        // 如果商品列表为空，跳过执行
        if (!newVal || newVal?.length === 0) {
          return;
        }
        await this.productIdForCoinPromise;
        let productId =
          this.productIdForCoin || globalConfig.getHrefParam('productId') || '';
        let cpProductId = globalConfig.getHrefParam('cpProductId') || '';
        let productList = newVal;
        if (this.matchCpProductid) {
          // 自动选中链接带的商品匹配product_id和cp_product_id
          if (productId && cpProductId && !this.hasAutoSelect) {
            const productItem = productList.find(
              item =>
                item.CP_PRODUCT_ID == cpProductId &&
                item.PRODUCT_ID == productId
            );
            if (productItem) {
              this.autoSelectProduct(productItem);
              return;
            } else {
              this.$store.commit(UPDATE_IS_AUTO_MATCH_PRODUCT, false);
              errorReport(ERROR_TYPE.AUTO_MATCH_PRODUCT_FAIL, {
                productId,
                cpProductId
              });
            }
          }
        } else {
          if (!this.hasAutoSelect && productList?.length > 0) {
            // 自动选中链接带的商品匹配product_id
            if (productId) {
              const productItem = productList.find(
                item => item.PRODUCT_ID == productId
              );
              if (productItem) {
                this.autoSelectProduct(productItem);
                return;
              } else {
                this.$store.commit(UPDATE_IS_AUTO_MATCH_PRODUCT, false);
                errorReport(ERROR_TYPE.AUTO_MATCH_PRODUCT_FAIL, {
                  productId,
                  cpProductId
                });
              }
            }
          }
        }
      }
    },
    lang(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$store.commit(UPDATE_HAS_SELECT_PRODUCT, false);
      }
    },
    searchVal(newVal) {
      // 防抖，输入后1s内内容不再变更才触发搜索打点
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        window.webstorev35DataLayer.push({
          eventName: 'search_product',
          eventType: PRODUCT_SEARCH_BY_NAME,
          eventReason: newVal
        });
      }, 1000);
    }
  },
  computed: {
    ...mapState({
      isLogin: state => state.isLogin,
      hasSelectProduct: state => state.hasSelectProduct,
      lang: state => state.lang,
      allProductList: state => state.productList,
      productHistory: state => state.productHistory,
      letter: state => state.letter,
      currency: state => state.showCurrency,
      hasLoadPaytype: state => state.hasLoadPaytype,
      isLogin: state => state.login.isLogin,
      uid: state => state.login.uid,
      gameId: state => state.gameId,
      serverId: state => state.pcServerId,
      roleId: state => state.roleId,
      roleName: state => state.roleName,
      cartList: state => state.cart.cartList,
      selectState: state => state.selectState,
      productDetailPopupVisible: state => state.productDetailPopupVisible,
      productDetailPopupProduct: state => state.productDetailPopupProduct,
      openShoppingCart: state => state.page.openShoppingCart,
      matchCpProductid: state => state.page.matchCpProductid,
      picList: state => state.page.picList,
      isCustomProductType: state => state.page.isCustomProductType,
      customProductTypeLang: state => state.page.customProductTypeLang,
      showCartList: state => state.cart.showCartList
    }),
    ...mapGetters(['cartProductType', 'isCart', 'gameInfoConfig']),
    showRealProductList() {
      return this.allProductList.length > 0 && this.roleId;
    },
    filterProductList() {
      return this.boolShowMoreProduct
        ? this.productList
        : this.productList?.slice?.(0, 12);
    },
    filterPreProductList() {
      return this.boolShowMoreProduct
        ? this.preProductList
        : this.preProductList?.slice?.(0, 12);
    },
    showMoreBtn() {
      if (this.showRealProductList) {
        return !this.boolShowMoreProduct && this.productList.length > 12;
      } else {
        return !this.boolShowMoreProduct && this.preProductList.length > 12;
      }
    },
    noSelectProduct() {
      return !this.hasSelectProduct;
    },
    productList() {
      let realProductList = [].concat(
        this.searchVal.length
          ? this.searchProductList
          : this.$store.state.productList
      );
      let _productList = this.filterHideProduct(realProductList);
      _productList = this.sortProductByHistory(_productList);
      _productList = this.filterUseGameCoupon(_productList);
      _productList = this.filterOrder(_productList);
      _productList = this.filterPrice(_productList);
      return _productList;
    },
    showToolBar() {
      return this.allProductList.length > 0;
    },
    showTypeBtn() {
      // 移动端：如果分类只有一种，隐藏分类按钮
      return this.productType?.length > 1;
    },
    searchProductList() {
      if (this.curSearchType === PRODUCT_SEARCH_BY_NAME) {
        return this.allProductList?.filter?.(item => {
          const boolProductName =
            item?.CP_PRODUCT_DESC?.toLowerCase?.()?.indexOf?.(
              this.searchVal?.toLowerCase?.()
            ) !== -1 ||
            item?.PRODUCT_DESC?.toLowerCase?.()?.indexOf?.(
              this.searchVal?.toLowerCase?.()
            ) !== -1;
          const boolProductDesc =
            this.getProductDetail(item)
              ?.toLowerCase?.()
              ?.indexOf?.(this.searchVal?.toLowerCase?.()) !== -1;
          return boolProductName || boolProductDesc;
        });
      } else {
        return this.$store.getters.getProductListByPrice(this.searchVal);
      }
    },
    selectProductTitle() {
      return this.letter.selectProductTitle;
    },
    titleIconStyle() {
      return `background-image: url(${this.picList?.allProductIcon})`;
    },
    productTypeImg() {
      return item => {
        return this.picList?.[item?.value] || '';
      };
    },
    currencyTypeName() {
      return this.productType?.find(item =>
        this.curProductType.includes(item.value)
      )?.name;
    },
    productTypeLang() {
      return {
        ...this.customProductTypeLang[this.lang],
        [PRODUCT_TYPE_ALL]: this.letter.typeall,
        [PRODUCT_TYPE_OTHER]: this.letter.typeother
      };
    },
    productType() {
      const TYPES_NAME = {
        coin: this.letter.coinTypeName,
        package: this.letter.packageTypeName,
        subscription: this.letter.subscriptionTypeName,
        currency: this.letter.currencyTypeName,
        typeall: this.letter.typeall
      };
      let res = [];
      if (this.$store.state.productTypes.length < 1) {
        this.curProductType = [];
        return res;
      }
      this.$store.state.productTypes.map(item => {
        if (item) {
          res.push({
            name: this.isCustomProductType
              ? this.productTypeLang[item]
              : this.letter[item] || TYPES_NAME[item],
            value: item
          });
        }
      });
      // 如果只有一个分类:就保留全部分类好了，【全部】是固定有的
      if (res.length === 2) {
        res = res?.filter?.(item => item.value === PRODUCT_TYPE_ALL) || [];
      }
      this.curProductType = [res[0].value];
      return res;
    },
    searchType() {
      return [
        { name: this.letter.product, value: PRODUCT_SEARCH_BY_NAME },
        { name: this.letter.price, value: PRODUCT_SEARCH_BY_PRICE }
      ];
    },
    searchPlaceholder() {
      return {
        name: this.letter.storeInputNameSearch,
        price: this.letter.storeInputPriceSearch
      };
    },
    curSearchTypeText() {
      return this.searchType.find(item => item.value === this.curSearchType)
        ?.name;
    }
  },
  methods: {
    showMoreProduct() {
      this.boolShowMoreProduct = true;
    },
    showTypeSelecterHandle() {
      this.isShowTypeSelecter = !this.isShowTypeSelecter;
    },
    hideTypeSelecterHandle() {
      this.isShowTypeSelecter = false;
    },
    showPriceSelecterHandle() {
      this.isShowPriceSelecter = !this.isShowPriceSelecter;
    },
    hidePriceSelecterHandle() {
      this.isShowPriceSelecter = false;
    },
    handlerPopup() {
      clickButton({
        btnName: 'pre_product_click',
        locationKey: locationType.homePage
      });
      if (!this.isLogin) {
        this.showLoginPopup();
        return;
      }
      this.showSelectRolePopup();
    },
    showAboutPopup() {
      this.visibleCurrenyGuidePopup = true;
      clickButton({
        btnName: 'about_currency_click',
        locationKey: locationType.homePage
      });
      showPopup(popupType.aboutCurrencyPopup);
    },
    lookCart() {
      this.$store.commit(UPDATE_SHOW_CARTLIST_STATUS, true);
    },
    autoSelectProduct(item) {
      this.$store.commit(UPDATE_IS_AUTO_MATCH_PRODUCT, true);
      this.hasAutoSelect = true;
      this.selectProduct(item);
    },
    selectProduct(item) {
      if (!this.roleId) {
        this.handlerPopup();
        return;
      }
      if (this.hasLoadPaytype) {
        this.changeProduct();
      }
      let productId = item.PRODUCT_ID,
        cpProductId = item.CP_PRODUCT_ID,
        remark = item.REMARK;

      this.updateSelectProduct(item);
      const serverId = this.$store.state.serverId;
      const roleId = this.$store.state.roleId;
      if (!serverId || !roleId) {
        alert(this.letter.seletGameInfoFirst);
        return;
      }
      // 搜索打点
      if (this.searchVal.length) {
        commonEmitUpload(
          `search-product-by-${this.curSearchType}`,
          {
            event: `search-product-by-${this.curSearchType}`,
            newPage: true,
            pageName: 'select-product-page',
            type: 'click'
          },
          this.searchVal
        );
      }
      commonEmitUpload(
        `j-select-product`,
        {
          event: `click-update-product`,
          pageName: 'select-product-page',
          type: 'click'
        },
        productId + ';' + cpProductId || ''
      );
      if (this.hasAutoSelect) {
        trackStagePoint('auto_select_product');
      }
      window.webstorev35DataLayer.push({
        eventName: 'select_product',
        eventType: 'buy_now',
        eventReason: this.hasAutoSelect ? 'auto_select' : 'click_select',
        eventValue: {
          product_type: item.PRODUCT_TYPE || '',
          cp_product_id: cpProductId,
          product_id: productId,
          product_num: 1,
          product_currency: this.currency,
          product_money: item.GAME_AMOUNT || ''
        }
      });
      window.webstorev35DataLayerBatch?.push({
        eventName: 'select_product',
        eventType: 'buy_now',
        eventReason: this.hasAutoSelect ? 'auto_select' : 'click_select',
        eventValue: {
          product_type: item.PRODUCT_TYPE || '',
          cp_product_id: cpProductId,
          product_id: productId,
          product_num: 1,
          product_currency: this.currency,
          product_money: item.GAME_AMOUNT || ''
        }
      });
      // 保存跳到储值页前的链接，为了返回时能获取跳过去前的信息
      this.saveLink({
        serverId,
        roleId,
        productId,
        cpProductId,
        remark,
        productType: item.PRODUCT_TYPE
      });
      storeProductParam({
        gameId: this.$store.state.gameId,
        serverId: this.$store.state.pcServerId,
        roleId: roleId,
        roleName: this.$store.state.roleName,
        packageName: globalConfig.getHrefParam('packageName'),
        userId: this.uid,
        productId: productId,
        cpProductId: cpProductId,
        devicePlate: globalConfig.getHrefParam('devicePlate'),
        remark: remark,
        location: getCurLocation() || '',
        appLanguage: this.$store.state.lang,
        language: this.$store.state.lang,
        productType: item.PRODUCT_TYPE
      });
      storeCpProductId(cpProductId);
      globalConfig.storeEntryParams();
      setDefaultPrice('');
      this.$store.commit(UPDATE_LOADING, true);
      this.$store.dispatch(LOAD_PAYTYPE_LIST_DATA);
    },
    saveLink(params) {
      const saveLinks =
        '?gameId=' +
        this.$store.state.gameId +
        '&serverId=' +
        params.serverId +
        '&roleId=' +
        params.roleId +
        '&roleName=' +
        encodeURIComponent(this.$store.state.roleName) +
        '&productId=' +
        params.productId +
        '&cpProductId=' +
        params.cpProductId +
        '&remark=' +
        params.remark +
        '&loginAccount=' +
        this.$store.state.login.loginAccount +
        '&userId=' +
        this.$store.state.login.uid +
        '&web=1' +
        '&language=' +
        this.$store.state.lang +
        '&appLanguage=' +
        this.$store.state.lang +
        '&fromIframe=' +
        isFromIframe +
        '&cid=' +
        globalConfig.getHrefParam('cid') +
        '&scid=' +
        globalConfig.getHrefParam('scid') +
        '&packageName=' +
        globalConfig.getHrefParam('packageName') +
        '&hideService=' +
        globalConfig.getHrefParam('hideService') +
        '&productType=' +
        params.productType +
        '#/web';
      sessionStorage.setItem('forwardLinksParam', saveLinks);
    },
    updateOrderType(value) {
      switch (value) {
        case PRODUCT_ORDER_BY_TYPE:
          this.showTypeSelecterHandle();
          return;
        case PRODUCT_ORDER_BY_PRICE_DOWN:
          this.curOrderType = PRODUCT_ORDER_BY_PRICE_DOWN;
          clickButton({
            btnName: 'switch_sorting',
            locationKey: 'price_down'
          });
          this.hidePriceSelecterHandle();
          break;
        case PRODUCT_ORDER_BY_PRICE_UP:
          this.curOrderType = PRODUCT_ORDER_BY_PRICE_UP;
          clickButton({
            btnName: 'switch_sorting',
            locationKey: 'price_up'
          });
          this.hidePriceSelecterHandle();
          break;
        default:
          break;
      }
    },
    getProductDefaultIcon(type) {
      return getProductDefaultImg(type);
    },
    updateSelectProduct(item) {
      this.selectItem = item;
      this.$store.commit(UPDATE_HAS_SELECT_PRODUCT, true);
    },
    changeProduct() {
      this.$store.commit(SET_HAS_LOAD_PAYTYPE, false);
      this.$store.commit(UPDATE_HAS_SELECT_PRODUCT, false);
      this.$store.commit(UPDATE_LOADING, false);
    },
    filterHideProduct(realProductList) {
      let productList = [];
      for (let key in realProductList) {
        //需求方：区天衡 -  如果CP_PRODUCT_ID为10_1_-1 11_1_-1 12_1_-1 13_1_-1 426005_1_-1，则不显示
        let hideProductArr = [
          '10_1_-1',
          '11_1_-1',
          '12_1_-1',
          '13_1_-1',
          '426005_1_-1'
        ];
        if (
          realProductList[key].CP_PRODUCT_ID &&
          hideProductArr.includes(String(realProductList[key].CP_PRODUCT_ID))
        ) {
          continue;
        }

        if (
          this.curProductType?.length > 0 &&
          !this.curProductType.includes(PRODUCT_TYPE_ALL) &&
          !this.curProductType.includes(realProductList[key].itemType)
        ) {
          continue;
        }

        productList.push(realProductList[key]);
      }

      return productList;
    },
    filterUseGameCoupon(productList) {
      if (
        this.gameActiveCouponId &&
        this.activeGameCouponProductList.length > 0
      ) {
        return productList.filter(item => {
          return this.checkInGameActiveCoupon(
            item.PRODUCT_ID,
            item.CP_PRODUCT_ID
          );
        });
      }
      return productList;
    },
    updateProductType(value) {
      clickButton({
        btnName: 'switch_producttype',
        locationKey: value
      });
      // this.hideTypeSelecterHandle();
      if (this.curProductType.includes(value)) {
        this.curProductType = this.curProductType.filter(
          item => item !== value
        );
      } else {
        if (value === PRODUCT_TYPE_ALL) {
          this.curProductType = [PRODUCT_TYPE_ALL];
        } else {
          this.curProductType = this.curProductType.filter(
            item => item !== PRODUCT_TYPE_ALL
          );
          this.curProductType.push(value);
        }
      }
    },
    selectType(type) {
      this.curSearchType = type;
      this.showSearchTypeSelecter = false;
    },
    filterOrder(productList) {
      let res = [];
      let isPackage =
        this.curProductType.length === 1 &&
        this.curProductType.includes('package');

      switch (this.curOrderType) {
        // 默认排序
        case PRODUCT_ORDER_BY_NORMAL: {
          let tagArr = [];
          let notagArr = [];
          // 先区分是否有tag
          productList.forEach(item => {
            // 只处理礼包的tag，非礼包的不处理
            if (isPackage) {
              if (item.PRODUCT_TAG) {
                // 插入的时候排一下序（tag权重）
                let orderIndex = tagArr.length - 1;
                let isAdd = false;
                while (~orderIndex) {
                  const preTagOrder = PACKAGE_TAG_LIST.indexOf(
                    tagArr[orderIndex].PRODUCT_TAG
                  );
                  const curTagOrder = PACKAGE_TAG_LIST.indexOf(
                    item.PRODUCT_TAG
                  );
                  if (preTagOrder >= curTagOrder) {
                    tagArr.splice(+orderIndex + 1, 0, item);
                    isAdd = true;
                    break;
                  } else {
                    orderIndex--;
                  }
                }
                if (!isAdd) {
                  tagArr.unshift(item);
                }
              } else {
                notagArr.push(item);
              }
            } else {
              notagArr.push(item);
            }
          });
          // 如果都没有tag，就可以结束了
          if (!tagArr.length) {
            res = notagArr;
            break;
          }
          res = tagArr.concat(notagArr);
          break;
        }
        // 价格升序
        case PRODUCT_ORDER_BY_PRICE_UP: {
          productList.sort((a, b) => {
            let bTagOrder = b.PRODUCT_TAG
              ? PACKAGE_TAG_LIST.indexOf(
                  String(b.PRODUCT_TAG).toLocaleLowerCase()
                )
              : -2;
            let aTagOrder = a.PRODUCT_TAG
              ? PACKAGE_TAG_LIST.indexOf(
                  String(a.PRODUCT_TAG).toLocaleLowerCase()
                )
              : -2;

            if (
              +b.GAME_AMOUNT > +a.GAME_AMOUNT ||
              (isPackage &&
                b.GAME_AMOUNT == a.GAME_AMOUNT &&
                bTagOrder < aTagOrder)
            ) {
              return -1;
            } else {
              return 1;
            }
          });

          res = productList;
          break;
        }
        // 价格降序
        case PRODUCT_ORDER_BY_PRICE_DOWN: {
          productList.sort((a, b) => {
            let bTagOrder = b.PRODUCT_TAG
              ? PACKAGE_TAG_LIST.indexOf(
                  String(b.PRODUCT_TAG).toLocaleLowerCase()
                )
              : -2;
            let aTagOrder = a.PRODUCT_TAG
              ? PACKAGE_TAG_LIST.indexOf(
                  String(a.PRODUCT_TAG).toLocaleLowerCase()
                )
              : -2;

            if (
              +b.GAME_AMOUNT < +a.GAME_AMOUNT ||
              (isPackage &&
                b.GAME_AMOUNT == a.GAME_AMOUNT &&
                bTagOrder < aTagOrder)
            ) {
              return -1;
            } else {
              return 1;
            }
          });

          res = productList;
          break;
        }
        default:
          break;
      }
      return res;
    },
    filterPrice(productList) {
      return productList.filter(item => {
        if (this.minPrice && this.maxPrice) {
          return (
            +item.GAME_AMOUNT >= +this.minPrice &&
            +item.GAME_AMOUNT <= +this.maxPrice
          );
        } else if (this.minPrice) {
          return +item.GAME_AMOUNT >= +this.minPrice;
        } else if (this.maxPrice) {
          return +item.GAME_AMOUNT <= +this.maxPrice;
        }
        return true;
      });
    },
    sortProductByHistory(productList) {
      // 将最近购买过的商品提前展示
      const preList = [];
      const remainList = [];

      for (const item of productList) {
        // 第一层循环是最近的每一笔订单
        const historyItem = this.productHistory?.find?.(billItemArr => {
          return (
            // 第二层循环是当前订单：这个订单里面有1个或者多个商品
            billItemArr?.find?.(billItem => {
              return (
                billItem?.cpProductId === item?.CP_PRODUCT_ID &&
                billItem?.productId === item?.PRODUCT_ID
              );
            }) || false
          );
        });
        if (historyItem) {
          Object.assign(item, {
            _recentBuy: true
          });
          preList.push(item);
        } else {
          remainList.push(item);
        }
      }

      return [...preList, ...remainList];
    },
    clearAllSearch() {
      this.minPrice = undefined;
      this.maxPrice = undefined;
      this.curOrderType = PRODUCT_ORDER_BY_NORMAL;
      this.curProductType = [PRODUCT_TYPE_ALL];
      this.searchVal = '';
      this.isGoSearch = false;
    },
    visibleShowSearchTypeSelecter(isShow) {
      this.showSearchTypeSelecter = isShow;
    },
    showProductDetailPopup(item) {
      this.showDeatilBtn = item.showBtn;
      this.$store.commit(SHOW_PRODUCT_DETAIL_POPUP, item);
    },
    hideProductDetailPopup() {
      this.$store.commit(CLOSE_PRODUCT_DETAIL_POPUP);
    },
    clearSearch() {
      this.searchVal = '';
      this.isGoSearch = false;
    },
    handleGoSeach() {
      this.isGoSearch = true;
      this.$nextTick(() => {
        this.$refs.searchInput.focus();
      });
    },
    async transformProductId() {
      // 内购礼包商品ID转代币商品ID：当商品不存在的时候自动转为价格相似的商品
      const game_id = globalConfig.getHrefParam('gameId');
      const product_id = globalConfig.getHrefParam('productId');
      const resolved = await this.$store.dispatch(RESOLVE_PRODUCT_ID_FOR_COIN, {
        gameId: game_id,
        productId: product_id
      });
      this.productIdForCoin = resolved || '';
      this.productIdForCoinResolve();
    },
    beforeAddToCartCheck(item, animateAddToCart) {
      if (!this.$store.state.roleId) {
        this.handlerPopup();
        return;
      }
      if (!this.havePayWay) {
        this.handleAreaConfirmPopup(true);
        return;
      }
      this.addToCart(item, animateAddToCart);
    }
  },
  components: {
    ProductItem,
    AboutCurrencyPopup,
    SearchTypeSelecter,
    ProductDetailPopup,
    CartSubmitFooter,
    RecommendProduct,
    AreaConfirmPopup,
    ZipCodeConfirmPopup,
    CommonUidTokenLoginPopup
  },
  directives: {
    clickoutside: clickOutside
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/officialTopupNew.scss';
@import '@assets/scss/officialTopupNew/_dimen.scss';

.layout-product {
  &-left {
    display: none;
  }
}

.select-product {
  width: 100%;
  margin: 0 auto;
  position: relative;
  z-index: 20;
  &.show-popup-status {
    z-index: 30;
  }
  .header-wrap-group {
    z-index: 6;
    position: sticky;
    top: -90px;
    padding: 0 0 10px;
    background-color: $backgroundColor;
  }
  .header-wrap {
    &.pc {
      display: none;
    }
    .title {
      font-size: 32px;
      font-weight: bold;

      &-icon {
        display: inline-block;
        width: 40px;
        height: 40px;
        margin-right: 10px;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        vertical-align: middle;
      }

      &-text {
        vertical-align: middle;
      }
    }
    .filter-btn {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 20px;

      .order-btn {
        flex: 1;
        box-sizing: border-box;
        width: 50%;
        height: 80px;
        padding: 0 20px;
        background-color: $moduleBackgroundColor;
        border: solid 1px #e8e8e8;
        font-size: 22px;
        text-align: start;
        border-radius: 10px;
        cursor: pointer;
        &-icon {
          flex-shrink: 0;
          width: 26px;
          height: 26px;
          color: #333333;

          &.active {
            transform: rotate(180deg);
          }
        }
      }
    }
  }

  .product-wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-content: space-between;
    padding-top: 20px;
    .tip {
      width: 100%;
      text-align: center;
      font-size: 24px;
      color: $themeColor;
    }
  }
  .product-more-wrap {
    text-align: center;
    margin: 20px auto 40px;
    .product-more-btn {
      display: inline-block;
      height: 60px;
      padding: 0 15px 0 20px;
      background-color: $moduleBackgroundColor;
      border: 1px solid #e9e9e9;
      font-size: 22px;
      line-height: 60px;
      text-align: center;
      color: #000000;
      border-radius: 30px;
      &-icon {
        display: inline-block;
        width: 24px;
        height: 24px;
        transform: translateY(4px);
      }
    }
  }
}

.search-input-wrap {
  height: 90px;
  border-radius: 10px;
  border: solid 3px $borderColor;
  padding: 0 36px;
  margin-bottom: 20px;
  position: relative;
  display: flex;
  align-items: center;
  background-color: $moduleBackgroundColor;

  .search-input {
    display: inline-block;
    box-sizing: border-box;
    width: 100%;
    padding: 0 40px 0 0;
    outline: none;
    background-color: transparent;
    background-size: cover;
    font-size: 22px;
    color: #333333;
    &::-webkit-search-cancel-button {
      display: none;
    }
    // &::-webkit-input-placeholder {
    //   font-size: 22px;
    // }
  }
  .search-input-ico {
    position: absolute;
    right: 36px;
    width: 30px;
    height: 30px;
  }
}

.order-type-popup {
  z-index: 6;
  box-sizing: border-box;
  overflow-y: scroll;
  position: absolute;
  top: unset;
  left: 0;
  width: 100%;
  max-height: 670px;
  background-color: #ffffff;
  border: 3px solid $borderColor;
  border-radius: 10px;

  &-close {
    z-index: -1;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    // background-color: rgba(0, 0, 0, 0.5);
  }

  .order-type-content {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    .product-type-select-item {
      position: relative;
      height: 120px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      cursor: auto;
      text-align: center;
      font-size: 22px;
      color: #333333;
      background: #ffffff;
      border: 1px solid #e8e8e8;
      box-sizing: border-box;
      z-index: 1;

      &-bg {
        z-index: -1;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        &.active {
          background-color: $themeColor;
          opacity: 0.2;
        }
      }

      &:hover {
        cursor: pointer;
        box-shadow: unset;
      }
      .type-img {
        width: 64px;
        height: auto;
        margin-bottom: 10px;
      }
      .type-check {
        position: absolute;
        top: 4px;
        right: 4px;
        width: 24px;
        height: 24px;
        background: linear-gradient(
          348deg,
          $buttonGradientColor1,
          $buttonGradientColor2
        );
        border-radius: 50%;

        &::after {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          width: 16px;
          height: 11px;
          background: url($commonImg + 'check.png') no-repeat center/contain;
          transform: translate(-50%, -50%);
        }
      }
    }
  }
}

.price-type-popup {
  z-index: 6;
  box-sizing: border-box;
  position: absolute;
  display: flex;
  flex-direction: column;
  width: calc(50% - 10px); // 减去gap的一半
  top: unset;
  right: 0;
  padding: 20px;
  border-radius: 10px;
  background-color: #ffffff;
  border: 3px solid $borderColor;

  &.left {
    width: 100%;
  }

  .price-item {
    padding: 20px 15px;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 22px;
    color: #333333;
    box-sizing: border-box;
    z-index: 1;
    &:first-child {
      border-bottom: 1px solid #e8e8e8;
    }
    &:hover {
      font-weight: bold;
    }
    &.active {
      font-weight: bold;
    }
  }
}

.unlogin-tip {
  text-align: center;
  font-size: 24px;
  color: #c1a15e;
}

.type-section {
  .product-type-select-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;
    &.expand {
      align-items: flex-start;
      .product-type-select {
        height: auto;
        .content {
          flex-wrap: wrap;
        }
        &-item {
          margin-bottom: 20px;
          margin-left: 0;
          margin-right: 20px;
        }
      }
    }
  }
  .product-type-select {
    overflow: -moz-scrollbars-none;
    overflow-x: hidden;
    overflow-y: auto;
    width: 616px;
    height: 50px;
    white-space: nowrap;
    touch-action: none;
    touch-action: pan-y;
    -ms-overflow-style: none;
    scrollbar-width: none;
    .content {
      display: flex;
      justify-content: flex-start;
    }
    &::-webkit-scrollbar {
      display: none;
      width: 0 !important;
    }
    &-item {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      padding: 0 20px;
      height: 50px;
      flex-shrink: 0;
      margin-left: 20px;
      cursor: auto;
      text-align: center;
      font-size: 22px;
      color: #333333;
      touch-action: none;
      touch-action: pan-y;
      background: #fff;
      border-radius: 30px;
      @include g-border(2px);
      box-sizing: border-box;
      &.active {
        touch-action: none;
        color: $themeColor;
        box-shadow: unset;
      }
      &:hover {
        cursor: pointer;
        box-shadow: unset;
      }
      &:last-child {
        margin-right: 0;
      }
      &:first-child {
        margin-left: 0;
      }
      .type-img {
        width: 32px;
        height: auto;
        margin-right: 14px;
      }
    }
    &-expand-switch {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #fff;
      padding: 0 20px;
      border-radius: 30px;
      border: 2px solid $border;
      box-sizing: border-box;
      height: 50px;
      cursor: pointer;
      .icon {
        display: inline-block;
        background: url($commonImg + 'channel-more.png') no-repeat;
        width: 20px;
        height: 19px;
        &.close {
          transform: rotate(180deg);
        }
      }
    }
  }
}

#ssr-page.landscape {
  .layout-product {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    &-left {
      overflow: hidden;
      flex-shrink: 0;
      display: block;
      position: sticky;
      top: 130px;
      width: 237px;
      margin-right: 20px;
      font-size: 24px;
      border-radius: 15px;
      background-color: var(--moduleBackgroundColor);
      font-size: 16px;

      &.unLogin {
        .left-wrap {
          padding-top: 20px;
        }
      }

      .clear-all-search {
        display: block;
        width: 100%;
        height: 52px;
        background-color: #323333;
        text-align: center;
        font-size: 16px;
        line-height: 52px;
        color: #ffffff;
      }

      .left-wrap {
        box-sizing: border-box;
        width: 100%;
        padding: 20px 15px 40px;
      }

      .search-input-wrap {
        height: 40px;
        margin: 0 auto 20px;
        padding: 0 10px;
        border-radius: 4px;

        > input {
          font-size: 16px;
        }
      }

      .classify {
        &-title {
          margin-bottom: 16px;
          font-weight: bold;
        }
        &-list {
          &-item {
            margin-bottom: 20px;
            &-wrap {
              display: flex;
              align-items: flex-start;
              justify-content: flex-start;
              cursor: pointer;

              &-select {
                flex-shrink: 0;
                box-sizing: border-box;
                display: inline-block;
                width: 20px;
                height: 20px;
                margin-right: 10px;
                border: 2px solid var(--borderColor);
                border-radius: 4px;
                vertical-align: middle;

                &.active {
                  position: relative;
                  border: 0;
                  background-color: $themeColor;

                  &::after {
                    content: '';
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    width: 16px;
                    height: 11px;
                    background: url($commonImg + 'check.png') no-repeat
                      center/contain;
                    transform: translate(-50%, -50%);
                  }
                }
              }
            }

            &-content {
              position: relative;
              &-icon {
                float: left;
                width: 35px;
                height: 20px;
                margin-right: 10px;
                background-color: #d1d0d1;
                border-radius: 4px;
                display: block;
                > img {
                  width: 100%;
                  height: 100%;
                  object-fit: contain;
                }
              }
              &-name {
                display: block;
                font-size: 16px;
                padding-left: 45px;
                white-space: normal;
                word-break: break-all;
                line-height: 20px;
              }
              &::after {
                content: '';
                display: table;
                clear: both;
              }
            }
          }
        }
      }

      .sort {
        &-title {
          margin-bottom: 16px;
          font-weight: bold;
        }
        &-list {
          &-item {
            margin-bottom: 20px;
            &-check {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              color: #333333;

              &-icon {
                display: inline-block;
                box-sizing: border-box;
                width: 20px;
                height: 20px;
                margin-right: 10px;
                border: 2px solid var(--borderColor);
                border-radius: 4px;
                vertical-align: middle;
              }

              &.active {
                color: $themeColor;
                .sort-list-item-check-icon {
                  position: relative;
                  border: 0;
                  background-color: $themeColor;

                  &::after {
                    content: '';
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    width: 16px;
                    height: 11px;
                    background: url($commonImg + 'check.png') no-repeat
                      center/contain;
                    transform: translate(-50%, -50%);
                  }
                }
              }
            }
          }
        }
      }

      .filter {
        &-title {
          margin-bottom: 16px;
          font-weight: bold;
        }
        &-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 16px;

          &-input {
            position: relative;
            width: 82px;
            height: 40px;

            &-bg {
              display: none;
              z-index: 1;
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-color: $themeColor;
              opacity: 0.1;
            }

            input {
              z-index: 2;
              position: relative;
              box-sizing: border-box;
              width: 100%;
              height: 100%;
              border: 1px solid var(--borderColor);
              border-radius: 4px;
              text-align: center;
              background-color: transparent;

              // 输入框聚焦时改变样式
              &:focus {
                border: 1px solid $buttonGradientColor1;
                // 使用相邻元素选择器设置filter-content-input-bg为block
                ~ .filter-content-input-bg {
                  display: block;
                }
              }
            }
          }
        }

        &-btn {
          display: block;
          width: 100%;
          height: 46px;
          background: linear-gradient(
            348deg,
            $buttonGradientColor1,
            $buttonGradientColor2
          );
          line-height: 46px;
          text-align: center;
          color: #ffffff;
          font-size: 16px;
          border-radius: 4px;
        }
      }
    }

    &-right {
      flex-shrink: 1;
    }
  }

  .select-product {
    width: 100%;
    padding: 0;
    .header-wrap-group {
      display: none;
    }
    .header-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: unset;

      &.pc {
        display: block;
      }
      .title {
        padding-top: 0;
      }
    }

    .product-wrap {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      margin-right: -20px;
      padding-top: 0;
      .tip {
        font-size: 18px;
      }
    }

    .product-more-wrap {
      .product-more-btn {
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        border-radius: 20px;

        &-icon {
          width: 18px;
          height: 18px;
        }
      }
    }
  }
  .order-type-popup {
    top: 90px;
    .order-type-content {
      grid-template-columns: repeat(5, 1fr);
      .product-type-select-item {
        font-size: 18px;
      }
    }
  }
  .price-type-popup {
    &.left {
      left: 50%;
    }
  }
  .type-section {
    .product-type-select {
      width: 770px;
      &-item {
        font-size: 18px;
      }
    }
  }
  .sort-and-search {
    .order-type-wrap {
      .order-btn {
        font-size: 18px;
      }
    }
    .search-content {
      width: 500px;
    }
    .search-wrap {
      font-size: 16px;
      .search-input {
        font-size: 16px;
      }
    }
  }
  .search-input-wrap {
    .search-input {
      margin-top: 4px;
    }
    .search-input-ico {
      right: 10px;
    }
  }
}
</style>
